export default {
  domain: 'plans',
  domainSingle: 'plan',
};
